exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper2[data-v-3b33e9b6]{width:100%;overflow-x:scroll;overflow-y:hidden;position:absolute;z-index:999;top:100px}#div2[data-v-3b33e9b6]{height:1px;overflow:scroll}\n", ""]);

// exports
